import type { Offer } from './types';

const formatAmount = (value: number) => value.toLocaleString('en-US');

export const formatRewardRange = (
  min: number,
  max: number,
  singular: string,
  plural: string
): string | null => {
  const safeMin = Number.isFinite(min) ? min : 0;
  const safeMax = Number.isFinite(max) ? max : 0;
  if (safeMin <= 0 && safeMax <= 0) return null;
  if (safeMin > 0 && safeMax > 0 && safeMin !== safeMax) {
    return `+${formatAmount(safeMin)}-${formatAmount(safeMax)} ${plural}`;
  }
  const value = safeMax > 0 ? safeMax : safeMin;
  return `+${formatAmount(value)} ${value === 1 ? singular : plural}`;
};

export const getTaskTicketsText = (task: Offer | undefined): string | null =>
  task ? formatRewardRange(task.minTickets, task.maxTickets, 'ticket', 'tickets') : null;

export const getTaskPointsText = (task: Offer | undefined): string | null =>
  task ? formatRewardRange(task.minPoints, task.maxPoints, 'pt', 'pts') : null;

export const getTaskThresholdText = (task: Offer | undefined): string | null => {
  const threshold = Number(task?.threshold ?? 0);
  return Number.isFinite(threshold) && threshold > 0 ? `$${formatAmount(threshold)}` : null;
};

export const getTaskMaxPoints =(task: Offer | undefined): number =>
  Number(task?.maxPoints || task?.minPoints || 0);

export const getTaskMaxTickets = (task: Offer | undefined): number =>
  Number(task?.maxTickets || task?.minTickets || 0);
